import { useEffect, useState } from "react"
import { observer } from "mobx-react-lite"

import { useScaleApplication } from "@/domains/application/use-scale-application"
import { DEFAULT_SLIPPAGE } from "@/domains/common/config/slippage"
import { SwapSlippageSection } from "@/domains/swap/components/composables/swap-settings-sections/swap-slippage-section"

/**
 * Business logic wrapper for SwapSlippageSection.
 * Handles MobX observer logic and scaleApp interactions.
 */
export const SwapSlippageSectionWrapper = observer(() => {
  const scaleApp = useScaleApplication()
  const storeSlippage = scaleApp?.Settings.slippage ?? DEFAULT_SLIPPAGE

  const [slippage, setSlippage] = useState(storeSlippage.toString())

  // Sync local state with store value
  useEffect(() => {
    setSlippage(storeSlippage.toString())
  }, [storeSlippage])

  const handleSlippageChanged = (newSlippage: string) => {
    setSlippage(newSlippage)
    const numValue = Number(newSlippage)
    if (!isNaN(numValue)) {
      scaleApp?.Settings.setSlippageFromUi(numValue)
    }
  }

  return <SwapSlippageSection slippage={slippage} onSlippageChanged={handleSlippageChanged} />
})
